import type { BorderStyleModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import { useSemanticModifierValue } from "@agent-ui/features/modifiers/hooks/useSemanticModifierValue";
import BorderStyleSelector from "@v2/features/modifiers/base/BorderStyleSelector";
import { useOverridableState } from "replo-runtime/shared/hooks/useOverridableState";

interface BorderStyleModifierProps {
  onChange: (modifier: BorderStyleModifierValue) => void;
}

const BorderStyleModifier: React.FC<BorderStyleModifierProps> = ({
  onChange,
}) => {
  const extractedStyle =
    useSemanticModifierValue({
      semanticExtractor: ({ computedStyles }) => {
        return computedStyles.borderTopStyle || "none";
      },
    }) ?? "none";

  const [currentStyle, setCurrentStyle] = useOverridableState(
    extractedStyle,
    React.useCallback(
      (style: string | null) => {
        const modifier: BorderStyleModifierValue = {
          type: "borderStyle",
          value: style as "solid" | "dashed" | "dotted" | "double",
        };
        onChange(modifier);
      },
      [onChange],
    ),
  );

  const handleStyleChange = React.useCallback(
    (style: string | null) => {
      setCurrentStyle(style ?? "none");
    },
    [setCurrentStyle],
  );

  return (
    <BorderStyleSelector
      borderStyle={currentStyle}
      onSelect={handleStyleChange}
    />
  );
};

export default BorderStyleModifier;
